import type { ReactNode } from 'react';

import './MaxWidthContentContainer.scss';

interface MaxWidthContentContainerProps {
  children: ReactNode;
}

export function MaxWidthContentContainer({ children }: MaxWidthContentContainerProps) {
  return <div className="MaxWidthContentContainer">{children}</div>;
}
